import { useQuery } from "@tanstack/react-query";
import { Database, Server, ShieldCheck, Store } from "lucide-react";
import { api } from "../lib/api";
import { number } from "../lib/format";
import { StatCard } from "../components/StatCard";
import { useI18n } from "../lib/i18n";

interface RuntimeResponse {
  runtime: {
    nodeEnv: string;
    database: string;
    demoMode: boolean;
    serverTarget: string;
  };
  counts: {
    stores: number;
    products: number;
    orders: number;
    availableStock: number;
  };
}

export function SettingsPage() {
  const { t } = useI18n();
  const query = useQuery({ queryKey: ["runtime"], queryFn: () => api.get<RuntimeResponse>("/api/settings/runtime") });
  const data = query.data;
  return (
    <div className="page-stack">
      <section className="stat-grid">
        <StatCard label={t("店铺")} value={number(data?.counts.stores ?? 0)} hint={t("已接入店铺")} icon={Store} />
        <StatCard label={t("商品")} value={number(data?.counts.products ?? 0)} hint={t("内部 SKU")} tone="blue" icon={Database} />
        <StatCard label={t("订单")} value={number(data?.counts.orders ?? 0)} hint={t("已同步订单")} tone="amber" icon={ShieldCheck} />
        <StatCard label={t("可用")} value={number(data?.counts.availableStock ?? 0)} hint={t("所有仓库可用库存")} icon={Server} />
      </section>

      <section className="panel settings-panel">
        <div className="panel-header">
          <div>
            <h2>{t("运行环境")}</h2>
            <span>{t("当前部署目标和数据库模式。")}</span>
          </div>
        </div>
        <dl className="settings-list">
          <div><dt>{t("运行模式")}</dt><dd>{data?.runtime.nodeEnv ?? "-"}</dd></div>
          <div><dt>{t("数据库")}</dt><dd>{data?.runtime.database ?? "-"}</dd></div>
          <div><dt>{t("演示数据")}</dt><dd>{data?.runtime.demoMode ? t("开启") : t("关闭")}</dd></div>
          <div><dt>{t("目标服务器")}</dt><dd>{data?.runtime.serverTarget ?? "-"}</dd></div>
          <div><dt>{t("生产数据库")}</dt><dd>{t("PostgreSQL，切换 DATABASE_URL 即可")}</dd></div>
          <div><dt>{t("部署方式")}</dt><dd>{t("Node.js + systemd + Nginx，无需 Docker")}</dd></div>
        </dl>
      </section>
    </div>
  );
}
